<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
    />

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div :class="isPrint ? 'col-span-2' : 'col-span-12 xl:col-span-2'" class="flex items-center" v-for="checkbox in form.inspectList" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #6670cb" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small" style="background-color: #6670cb"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox color="secondary" :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <TableInspectMerge
      v-for="inspection in form.inspectList"
      :key="`inspection_${inspection.title}`"
      v-show="inspection.check"
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="inspection.title"
      :tableHeaderTitle="inspection.tableHeaderTitle ? inspection.tableHeaderTitle : '점검항목'"
      v-model="inspection.list"
      :table-header-note="[{ text: '비고', width: '288' }]"
      :table-header-check="[
        { text: '양호', value: 'Yes', width: '82' },
        { text: '미흡', value: 'No', width: '82' },
        { text: '해당없음', value: 'N/A', width: '82' },
      ]"
      :only-pc="isPrint"
    />

    <!-- 현장근로자 의견 청취 및 특이사항 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>현장근로자 의견 청취 및 특이사항</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div style="line-height: 1.4; word-break: keep-all">현장근로자 의견 청취</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputC_1.fileName }}
          </p>
          <file-uploader v-else :readonly="board.readonly" v-model="form.inputC_1" />
        </div>
        <div class="writeGridLineItem">
          <div>특이사항</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputC_2 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputC_2" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 유해·위험요인 개선 결과 -->
    <ImprovementTable :readonly="board.readonly" :isPrint="isPrint" v-model="form.개선결과" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploader from "@/components/FileUploader";
import TableInspectEp from "@/components/TableInspectCustomEp";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import ImprovementTable from "./improvementTable.vue";

import inspectData from "./inspectData";

export default {
  components: {
    TableInspectMerge,
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    ImprovementTable,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    postId() {
      return this.$route.params.postId;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.postId && key === "개선결과" && value[key]) {
            value[key].forEach((item) => {
              const 원본문자 = item.개선내용;

              // 담당자와 개선일자 있는지 검사
              const has담당자 = 원본문자.includes("- 담당자");
              const has개선일자 = 원본문자.includes("- 개선일자");

              if (has담당자 && has개선일자) {
                console.log("원본", 원본문자);
                // 값 추출
                const 담당자Match = 원본문자.match(/- 담당자\s*:(.*)/);
                const 개선일자Match = 원본문자.match(/- 개선일자\s*:(.*)/);
                const 개선내용Match = 원본문자.match(/- 개선내용\s*:?\s*([\s\S]*?)(?:- 개선일자|$)/);

                const 담당자 = 담당자Match ? 담당자Match[1].trim() : null;
                const 개선일자 = 개선일자Match ? 개선일자Match[1].trim() : null;
                const 개선내용 = 개선내용Match ? 개선내용Match[1].trim() : "";

                item.개선내용담당자 = 담당자;
                item.개선내용개선일자 = 개선일자;
                item.개선내용 = 개선내용;
              }
            });
          }

          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label);
        }
      }
    },
    updateListCheck(indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text;
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputC_1: {},
        inputC_2: "",

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],

        개선결과: [],
      },

      inspectTable: JSON.parse(JSON.stringify(inspectData)),
    };
  },
};
</script>

<style scoped lang="scss"></style>
